export default __webpack_public_path__ + "static/OperatorMono-BookItalic_Web-24f1b82aff8066cf3eefc221c2121e6b.woff2";